import { render, staticRenderFns } from "./parcelbox.vue?vue&type=template&id=344841c9&scoped=true&"
import script from "./parcelbox.vue?vue&type=script&lang=js&"
export * from "./parcelbox.vue?vue&type=script&lang=js&"
import style0 from "./parcelbox.vue?vue&type=style&index=0&id=344841c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344841c9",
  null
  
)

export default component.exports